import { AppointmentType, ParticipantsOfAppointment } from 'src/models/appointment';

import { Callback } from 'src/util/query/models/Callback';

import { ChangeAppointmentTypeDependencies } from '../interfaces';

export class ChangeAppointmentTypeOfSubmittedAppointmentIdCallBack extends Callback<AppointmentType> {
	public constructor(
		private readonly aggregateId: string,
		private readonly dependencies: ChangeAppointmentTypeDependencies
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: AppointmentType): void => {
		const updatedAppointmentTypeId = Number(successResponse.updatedAppointmentTypeId);

		this.dependencies.updateTheAppointmentType({
			aggregateId: this.aggregateId,
			appointmentType: updatedAppointmentTypeId,
		});

		this.dependencies.updateTheAppointmentParticipants({
			aggregateId: this.aggregateId,
			participantsOfAppointment: successResponse.fullUserlistWithParticipants
				.filter((participant) => participant.hidden === 'false')
				.map(
					(participant): ParticipantsOfAppointment => ({
						Displayname: participant.Displayname,
						Fullname: participant.Fullname,
						UserAvatar: participant.UserAvatar,
						accept: participant.accept,
						active: participant.active,
						alert: participant.alert,
						confirmed: participant.confirmed ?? 'vague',
						hidden: null,
						memberId: parseInt(participant.memberId, 10) || 0,
						userId: parseInt(participant.userId, 10),
						write: participant.write,
					})
				),
		});

		this.dependencies.updateTheAppointmentIdoButton({
			aggregateId: this.aggregateId,
			idoButton: successResponse.idoButton,
		});

		const appointment = this.dependencies.appointment(this.aggregateId);
		if (appointment === undefined) {
			return;
		}

		const calendarModelColors = appointment.calendarModelColors.find(
			(calendarModelColor) => Number(calendarModelColor.appointmentTypeId) === updatedAppointmentTypeId
		);
		if (calendarModelColors === undefined) {
			return;
		}

		this.dependencies.updateTheAppointmentTimeMode({
			aggregateId: this.aggregateId,
			appointmentTimeMode: calendarModelColors.appointmentTimeType ?? '',
		});

		this.dependencies.updateTheAppointmentAccess({
			access: calendarModelColors.appointmentTypeAccess ?? '',
			aggregateId: this.aggregateId,
		});

		this.dependencies.updateTheAppointmentAlert({
			aggregateId: this.aggregateId,
			appointmentAlert: calendarModelColors.appointmentTypeAlert ?? 0,
		});
	};
}
